import { Processo } from "@/models/processo-eletronico/processo";
import { ProcessoAPI } from "@/api/processo-eletronico/processo.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";

const processoAPI = new ProcessoAPI();

const findByViproc = (
  identificadorViproc: string,
  recaptcha: string
): AxiosObservable<Processo> => {       
  return processoAPI.findByViproc(identificadorViproc, recaptcha);
};

export default { findByViproc };
